/* global Sys, Core */
Sys.ns("Core");

/**
 * The Keep Alive controller. This continuously polls an url in intervals to keep a connection
 * alive, hence the 'keep alive'.
 *
 * @class Core.KeepAliveController
 * @extends Core.Controller
 */
Core.KeepAliveController = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.KeepAliveController.superclass.constructor.apply(this, arguments);

        if (this.model.readData("url")) {
            this.keepAlive();
        }
    },

    /**
     * Make a request to the specified url and set up a timeout for another request based
     * on the supplied interval.
     *
     * @private
     * @returns {void}
     */
    keepAlive: function() {
        var me = this,
            interval = this.model.readData("interval"),
            request = Sys.utils.httpGet({
                url: this.model.readData("url"),
                handleError: false,
                showTimeoutDialog: false
            });

        request.always(function() {
            setTimeout(function() {
                me.keepAlive();
            }, interval);
        });
    }
};

Core.KeepAliveController = Sys.extend(Core.Controller, Core.KeepAliveController, "Core.KeepAliveController");
